const FACTS = ['214° — FIRST CRACK', 'ПОМЕЛ ПІД ЗАМОВЛЕННЯ', 'ВІДПРАВКА НАСТУПНОГО ДНЯ'];

// Стрічка зсувається на −50% своєї ширини, тож дві половини мають бути
// однакові й кожна — ширша за екран (≈2800px, з запасом на 2560px-монітори):
// три короткі факти повторюємо 4 рази в кожній половині.
const COPIES_PER_HALF = 4;
const TRACK = Array.from({ length: COPIES_PER_HALF * 2 }, () => FACTS).flat();

export function Ticker() {
  return (
    <div className="overflow-hidden border-b border-line py-4" aria-hidden="true">
      {/* Довша стрічка — довший прохід, щоб швидкість лишилась як раніше (34 с на ~1200px). */}
      <div className="flex w-max animate-marquee" style={{ animationDuration: '80s' }}>
        {TRACK.map((fact, index) => (
          <span
            // biome-ignore lint/suspicious/noArrayIndexKey: FACTS is a static duplicated list with repeated text, index is needed to disambiguate keys
            key={`${fact}-${index}`}
            className="whitespace-nowrap px-8 font-mono text-[11px] uppercase tracking-[0.14em] text-muted"
          >
            {fact}
          </span>
        ))}
      </div>
    </div>
  );
}
